import { computed, resolveComponent, openBlock, createBlock, withCtx, withDirectives, createElementVNode, normalizeClass, normalizeStyle, renderSlot, vShow } from 'vue';
import { createComponent } from './utils/create-component';
import propTypes from './utils/prop-types';
import { CLICK_EVENT, INPUT_EVENT } from './utils/constants';
import { preventDefault } from './utils/dom';
import Transition from './transition';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var props = {
  /**
   * 蒙层是否显示
   */
  modelValue: propTypes["boolean"]().def(false),
  /**
   * 蒙层层级
   */
  zIndex: propTypes.oneOfType([propTypes.string(), propTypes.number()]),
  /**
   * 动画时长，单位毫秒
   */
  duration: propTypes.oneOfType([propTypes.string(), propTypes.number()]),
  /**
   * 自定义蒙层类名
   */
  maskClass: propTypes.string(),
  /**
   * 自定义蒙层样式
   */
  maskStyle: propTypes.object(),
  /**
   * 是否锁定背景滚动，锁定时蒙层里的内容也将无法滚动
   */
  lockScroll: propTypes["boolean"]().def(true),
  /**
   * 是否点击蒙层关闭
   */
  maskCloseable: propTypes["boolean"]().def(true),
  transition: propTypes.string().def('mask-transition')
};
var emits = [CLICK_EVENT, INPUT_EVENT];

var _createComponent = createComponent('mask'),
  create = _createComponent.create,
  className = _createComponent.className;
var script = create({
  components: _defineProperty({}, Transition.name, Transition),
  props: props,
  emits: emits,
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    var style = computed(function () {
      var style = {};
      if (props.duration) {
        style.animationDuration = "".concat(+props.duration / 1000, "s");
      }
      if (props.zIndex) {
        style.zIndex = props.zIndex;
      }
      return _objectSpread2(_objectSpread2({}, style), props.maskStyle);
    });
    function onClick(e) {
      emit(CLICK_EVENT, e);
      props.maskCloseable && emit(INPUT_EVENT, false);
    }
    function onTouchMove(e) {
      props.lockScroll && preventDefault(e, true);
    }
    return {
      className: className,
      style: style,
      onClick: onClick,
      onTouchMove: onTouchMove
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_sp_transition = resolveComponent("sp-transition");
  return openBlock(), createBlock(_component_sp_transition, {
    name: _ctx.transition
  }, {
    "default": withCtx(function () {
      return [withDirectives(createElementVNode("div", {
        "class": normalizeClass([_ctx.className, _ctx.maskClass]),
        style: normalizeStyle(_ctx.style),
        onClick: _cache[0] || (_cache[0] = function () {
          return _ctx.onClick && _ctx.onClick.apply(_ctx, arguments);
        }),
        onTouchmove: _cache[1] || (_cache[1] = function () {
          return _ctx.onTouchMove && _ctx.onTouchMove.apply(_ctx, arguments);
        }),
        onMousewheel: _cache[2] || (_cache[2] = function () {
          return _ctx.onTouchMove && _ctx.onTouchMove.apply(_ctx, arguments);
        }),
        onDblclick: _cache[3] || (_cache[3] = function () {
          return _ctx.onTouchMove && _ctx.onTouchMove.apply(_ctx, arguments);
        })
      }, [renderSlot(_ctx.$slots, "default")], 38 /* CLASS, STYLE, HYDRATE_EVENTS */), [[vShow, _ctx.modelValue]])];
    }),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]);
}

script.render = render;
script.__file = "components/src/component/mask/mask.vue";

/*
 * @Description: Mask 蒙层组件导出文件
 * @Author: duqiao@kuaishou.com
 * @Date: 2022-02-24 20:07:19
 * @LastEditors: zhoushichao@kuaishou.com
 * @LastEditTime: 2023-02-02 11:06:58
 */
var _Mask = script;

export { _Mask as default };
